export const PlanStatusType = {
  Waiting: "Waiting",
  OnRoad: "OnRoad",
  WaitMeeting: "WaitMeeting",
  Meeting: "Meeting",
  SaleCompleted: "SaleCompleted",
  SaleCancelled: "SaleCancelled",
  MeetAgain: "MeetAgain",
  CustomerUnreachable: "CustomerUnreachable",
  Cancelled: "Cancelled",
  DemoMade: "DemoMade",
  TrialMade: "TrialMade",
};

const planStatus = [
  {
    type: PlanStatusType.Waiting,
    textColor: "#C7A630",
    bgColor: "#ffd12d21",
    text: "Bekleniyor",
    variant: "warning",
  },
  {
    type: PlanStatusType.OnRoad,
    textColor: "#FC7100",
    bgColor: "#FFDFAF",
    text: "Yolda",
    variant: "warning",
  },
  {
    type: PlanStatusType.WaitMeeting,
    textColor: "#a9854f",
    bgColor: "#f2debf",
    text: "Görüşme Bekleniyor",
    variant: "warning",
  },
  {
    type: PlanStatusType.Meeting,
    textColor: "#FC7100",
    bgColor: "#FFDFAF",
    text: "Görüşmede",
    variant: "warning",
  },
  {
    type: PlanStatusType.SaleCompleted,
    textColor: "#68BF10",
    bgColor: "#E5F3DF",
    text: "Satış Yapıldı",
    variant: "success",
  },
  {
    type: PlanStatusType.DemoMade,
    textColor: "#68BF10",
    bgColor: "#E5F3DF",
    text: "Demo Yapıldı",
    variant: "success",
  },
  {
    type: PlanStatusType.TrialMade,
    textColor: "#68BF10",
    bgColor: "#E5F3DF",
    text: "Görüşme Tamamlandı",
    variant: "success",
  },
  {
    type: PlanStatusType.SaleCancelled,
    textColor: "#112751",
    bgColor: "#11275121",
    text: "Ziyaret Edildi",
    variant: "success",
  },
  {
    type: PlanStatusType.MeetAgain,
    textColor: "#68BF10",
    bgColor: "#E5F3DF",
    text: "Tekrar Görüşme",
    variant: "success",
  },
  {
    type: PlanStatusType.CustomerUnreachable,
    textColor: "#e1473d",
    bgColor: "#ffe1df",
    text: "Müşteriye Ulaşılamadı",
    variant: "success",
  },
  {
    type: PlanStatusType.Cancelled,
    textColor: "#e1473d",
    bgColor: "#ffe1df",
    text: "İptal Edildi",
    variant: "danger",
  },
];

/**
 * Returns the plan status object that matches the given status.
 *
 * @param {string} status - The status to search for.
 * @return {Object|undefined} The plan status object that matches the given status, or undefined if not found.
 */
export const getPlanStatus = (status) => {
  const findStatus = planStatus.find((item) => item.type === status);

  return (
    findStatus || {
      type: "noFound",
      text: "noFound",
      variant: "danger",
      bgColor: "#ffe1df",
      textColor: "#ffe1df",
    }
  );
};

export const getCountsOfStatusByGroups = (items) => {
  const counts = items.reduce((acc, item) => {
    const status = getPlanStatus(item.status);
    acc[status.variant]
      ? (acc[status.variant].count += 1)
      : (acc[status.variant] = { ...status, count: 1 });
    return acc;
  }, {});
  console.log(counts);
  return counts;
};
